<template>
  <div id="app">
    <router-view v-if="liffReady" />
  </div>
</template>

<script>
import axios from 'axios'
import { injectLiffMock } from '@/utils/liffMock'

const IS_DEV = process.env.NODE_ENV === 'development'

export default {
  name: 'App',
  data() {
	  return {
		liffReady: false,
	  }
	},
  
	mounted() {
    if (IS_DEV) {
      injectLiffMock()
    }
    
    // 抓 query liff.state
    const liffState = new URLSearchParams(window.location.search).get('liff.state')
    console.log('liffState :>> ', liffState);
    if (!liff.isInClient() && !liffState) {
      this.liffReady = true;
      console.log('非 LINE 內建瀏覽器，不需登入驗證，直接繼續')
      return
    }

	  const liffId = '1656184654-SjsXGPT7'
	  liff.init({
		  liffId: liffId
	  }).then(() => {
		if (liff.isLoggedIn()) {
      console.log('liff isLoggedIn');
		  liff.getProfile().then(async (profile) => {
			this.$store.commit('set_openid', profile.userId)
  
			let { data } = await axios.post(`https://nike.cheflemon.co/api/dna`, {
			  userId: profile.userId
			});
  
			if (!data.completed) {
			  // Redirect to DNA Tester.
			  alert("請先完成隱私權同意與運動喜好調查");
			  location.href = `https://nike.cheflemon.co/dna?r=${encodeURIComponent(location.href)}`;
  
			  return ;
			}
		  
			let { friendFlag } = await liff.getFriendship();
			if (!friendFlag) {
			  alert("請先加入或解封鎖 Nike Taiwan Line 官方帳號");
			  window.location = "https://lin.ee/szYWuxa6";
			  return ;
			}
			this.liffReady = true
		  }).catch((err) => {
			console.log('liff getProfile failed', err)
		  })
		} else {      
      liff.login()  
		}
	  }).catch((err) => {
		  console.log('liff initialization failed', err)
	  })
	} 
}
</script>

<style lang="less">

  @font-face {
    font-family: 'fs-regular';
    src: local('Noto Sans TC'),
         url('https://fonts.gstatic.com/s/notosanstc/v35/nKKF-GM_FYFRJvXzVXaAPe97P1K9s9oBM0OqATF.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'fs-medium';
    src: local('Noto Sans TC Medium'),
         url('https://fonts.gstatic.com/s/notosanstc/v35/nKKF-GM_FYFRJvXzVXaAPe97P1K9s9oBM0OqC7F.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'fs-bold';
    src: local('Noto Sans TC Bold'),
         url('https://fonts.gstatic.com/s/notosanstc/v35/nKKF-GM_FYFRJvXzVXaAPe97P1K9s9oBM0Oqe7F.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: 'en-bold';
    src: url('./assets/fonts/Helvetica Now Display Bold.otf');
    font-display: swap;
  }

  @font-face {
    font-family: 'en-medium';
    src: url('./assets/fonts/Helvetica Now Display Medium.otf');
    font-display: swap;
  }

  @font-face {
    font-family: 'en-display';
    src: url('./assets/fonts/Helvetica Now Display.otf');
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    width: 100vw;
    height: 100vh;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  #app {
    width: 100%;
    height: 100%;
  }

  .container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    overflow: hidden;
    color: #fff;
    background-color: #000;
  }

  .btn {
    transition: all 0.1s;
    &:active {
      transform: scale(0.9);
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue